import script from "./BrushMapAside.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapAside.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapAside.vue?vue&type=style&index=0&id=6cca2b8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cca2b8e"]])

export default __exports__